import { render, staticRenderFns } from "./GroupExtension.vue?vue&type=template&id=a3c841ca&"
import script from "./GroupExtension.vue?vue&type=script&lang=js&"
export * from "./GroupExtension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports